import LocalizedStrings from "react-localization";

import en from "./languages/en";

const STRINGS = new LocalizedStrings({
  en,
});

export default STRINGS;
